/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Overview_Genres1Inputs */

const id_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genre`)
};

const ms_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genre`)
};

const da_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genrer`)
};

const de_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genres`)
};

const en_us2_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genres`)
};

const es_es2_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Géneros`)
};

const es_mx2_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Géneros`)
};

const fil_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Genre`)
};

const fr_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genres`)
};

const it_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generi`)
};

const hu_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Műfajok`)
};

const nl_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genres`)
};

const no_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sjangre`)
};

const pl_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gatunki`)
};

const pt_br2_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gêneros`)
};

const pt_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Géneros`)
};

const ro_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genuri`)
};

const fi_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lajityypit`)
};

const sv_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genrer`)
};

const vi_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thể loại`)
};

const tr_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türler`)
};

const cs_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žánry`)
};

const bg_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жанрове`)
};

const ru_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жанры`)
};

const uk_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жанри`)
};

const ar_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأنواع`)
};

const hi_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शैलियाँ`)
};

const th_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แนวเกม`)
};

const ja_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ジャンル`)
};

const zh_cn2_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`类型`)
};

const zh_hant1_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`類型`)
};

const ko_offerdetail_overview_genres1 = /** @type {(inputs: Offerdetail_Overview_Genres1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`장르`)
};

/**
* | output |
* | --- |
* | "Genres" |
*
* @param {Offerdetail_Overview_Genres1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_overview_genres1 = /** @type {((inputs?: Offerdetail_Overview_Genres1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Overview_Genres1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_overview_genres1(inputs)
	if (locale === "ms") return ms_offerdetail_overview_genres1(inputs)
	if (locale === "da") return da_offerdetail_overview_genres1(inputs)
	if (locale === "de") return de_offerdetail_overview_genres1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_overview_genres1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_overview_genres1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_overview_genres1(inputs)
	if (locale === "fil") return fil_offerdetail_overview_genres1(inputs)
	if (locale === "fr") return fr_offerdetail_overview_genres1(inputs)
	if (locale === "it") return it_offerdetail_overview_genres1(inputs)
	if (locale === "hu") return hu_offerdetail_overview_genres1(inputs)
	if (locale === "nl") return nl_offerdetail_overview_genres1(inputs)
	if (locale === "no") return no_offerdetail_overview_genres1(inputs)
	if (locale === "pl") return pl_offerdetail_overview_genres1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_overview_genres1(inputs)
	if (locale === "pt") return pt_offerdetail_overview_genres1(inputs)
	if (locale === "ro") return ro_offerdetail_overview_genres1(inputs)
	if (locale === "fi") return fi_offerdetail_overview_genres1(inputs)
	if (locale === "sv") return sv_offerdetail_overview_genres1(inputs)
	if (locale === "vi") return vi_offerdetail_overview_genres1(inputs)
	if (locale === "tr") return tr_offerdetail_overview_genres1(inputs)
	if (locale === "cs") return cs_offerdetail_overview_genres1(inputs)
	if (locale === "bg") return bg_offerdetail_overview_genres1(inputs)
	if (locale === "ru") return ru_offerdetail_overview_genres1(inputs)
	if (locale === "uk") return uk_offerdetail_overview_genres1(inputs)
	if (locale === "ar") return ar_offerdetail_overview_genres1(inputs)
	if (locale === "hi") return hi_offerdetail_overview_genres1(inputs)
	if (locale === "th") return th_offerdetail_overview_genres1(inputs)
	if (locale === "ja") return ja_offerdetail_overview_genres1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_overview_genres1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_overview_genres1(inputs)
	return ko_offerdetail_overview_genres1(inputs)
});
export { offerdetail_overview_genres1 as "offerDetail.overview.genres" }